
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface PremiumContentOverlayProps {
  show?: boolean;
}

/**
 * Overlay displayed over the article content prompting users to subscribe.
 */
const PremiumContentOverlay = ({ show = true }: PremiumContentOverlayProps) => {
  // Subscription UI removed — overlay disabled
  return null;
};

export default PremiumContentOverlay;
